import React, { Component } from "react";
import { Button, Card, Form, Input, notification } from "antd";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { Row, Col } from 'react-bootstrap';

import CircularProgress from "components/CircularProgress";
import Auxiliary from "util/auxiliary";
import PageHeader from "components/PageHeader";

import {
  addEventTitle,
  updateEventTitle,
  resetEventTitle
} from "./../../../appRedux/actions/eventTitle";

const FormItem = Form.Item;

class AddEventTitle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editId: null
    }

    this.formRef = React.createRef();
  };

  componentDidMount() {
    if (this.props.match.params.id) {
      const { authUser } = this.props.auth;
      const INSTANCE = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '.concat(authUser.token)
        }
      });

      let inputJSON = JSON.stringify({
        _id: this.props.match.params.id
      })

      INSTANCE.post("event-title/get-by-id", inputJSON)
        .then((response) => {
          if (response.data.messageId === 200) {
            this.formRef.current.setFieldsValue({
              name: response.data.data.name,
              description: response.data.data.description ? response.data.data.description : ''
            });
            this.setState({
              editId: this.props.match.params.id
            })
          }
        })
        .catch((error) => {
        })
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.eventTitle) {
      if (nextProps.eventTitle.messageId === 200) {
        notification['success']({
          message: 'Success',
          description: nextProps.eventTitle.alertMessage
        });
        nextProps.resetEventTitle();
      } else if (nextProps.eventTitle.messageId === 203) {
        notification['error']({
          message: 'Alert!!',
          description: nextProps.eventTitle.alertMessage
        });
        nextProps.resetEventTitle();
      }
      return true;
    }
    return null;
  }

  onFinish = values => {
    const { authUser } = this.props.auth;
    const { editId } = this.state;
    if (editId) {
      let inputJSON = values;
      inputJSON._id = editId;
      this.props.updateEventTitle(authUser.token, inputJSON);
    } else {
      this.props.addEventTitle(authUser.token, values);
    }
  };

  render() {
    const { loader } = this.props.eventTitle;
    const { editId } = this.state;
    return (
      <>
        {loader ?
          <div className="gx-loader-view">
            <CircularProgress />
          </div> :
          <Auxiliary>
            <PageHeader title={editId ? "Edit Event Title" : "Add Event Title"} />
            <Row className="row-margin2">
              <Col>
                <Card>
                  <Form
                    name="eventTitleForm"
                    onFinish={this.onFinish}
                    layout="vertical"
                    ref={this.formRef}
                  >
                    <FormItem label="Event Title Name" rules={[{ required: true, message: 'Please enter event title name.' }]} name="name">
                      <Input placeholder="Event Title Name" />
                    </FormItem>

                    <FormItem label="Description" name="description">
                      <Input.TextArea placeholder="Description" rows={4} />
                    </FormItem>

                    <FormItem>
                      <Button loading={loader} className="gx-mb-0" type="primary" htmlType="submit">
                        {editId ? "Update" : "Submit"}
                      </Button>
                    </FormItem>
                  </Form>
                </Card>
              </Col>
            </Row>
          </Auxiliary>
        }
      </>
    );
  }
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    eventTitle: state.eventTitle
  }
}

function mapDispathToProps(dispatch) {
  return bindActionCreators({ addEventTitle, updateEventTitle, resetEventTitle }, dispatch);
}

export default connect(mapStateToProps, mapDispathToProps)(AddEventTitle);
